export function Footer() {
  const footer = document.createElement("footer");

  footer.className = "site-footer";
  footer.textContent = `© ${new Date().getFullYear()} The Lazy Company LLC`;

  return footer;
}
